import graphql from 'babel-plugin-relay/macro';

/**
 * Fragment
 */
export const PRODUCT_FRAGMENT = graphql`
  fragment productFragment on Product @inline {
    id
    externalRef
    accountId
    name
    description
    type
    price
    currencyCode
    meta
    createdAt
  }
`;

/**
 * Query
 */
export const PRODUCTS_QUERY = graphql`
  query productsQuery($first: Int!, $after: String, $ordering: [ProductOrdering!], $filter: ProductFilter) {
    products(first: $first, after: $after, ordering: $ordering, filter: $filter) {
      count
      edges {
        node {
          ...productFragment
        }
      }
    }
  }
`;

export const PRODUCT_QUERY = graphql`
  query productQuery($id: ID!) {
    product(id: $id) {
      ...productFragment
    }
  }
`;
